module.exports = __webpack_public_path__ + "img/product-05.c8822ce5.jpg";